var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLInkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.014 19.255v-7.1c0-3.803-2.03-5.573-4.738-5.573-2.184 0-3.163 1.202-3.709 2.045V6.873H7.451c.055 1.162 0 12.382 0 12.382h4.116V12.34c0-.369.027-.739.136-1.003.297-.74.974-1.505 2.11-1.505 1.49 0 2.086 1.135 2.086 2.8v6.624h4.115zM3.115 5.183c1.435 0 2.33-.952 2.33-2.14C5.416 1.829 4.55.904 3.141.904 1.735.904.814 1.828.814 3.043c0 1.188.894 2.14 2.275 2.14h.026zm2.058 14.072V6.873H1.058v12.382h4.115z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLInkedIn);
export default __webpack_public_path__ + "static/media/l-inked-in.e9ba01e82e189c93637107dbe3f5192b.svg";
export { ForwardRef as ReactComponent };